import StackKit from "@/shared/components/kit/stack";
import ContainerCustom from "@/shared/components/common/content";
import HeaderShare from "@/shared/components/common/header";
import { LogoMerchant } from "@/shared/components/common/icons";
import Sidebar from "../components/sidebar";
import { ThemeProvider } from "@emotion/react";
import { CssBaseline } from "@mui/material";
import theme from "../theme";
import BoxKit from "@/shared/components/kit/box";
import SidebarMobile from "../components/sidebar/menuSidebar";
import { useState } from "react";

type LayoutProps = {
  children: React.ReactNode;
};
/**
 * Layout
 *
 * لایه اصلی اپلیکیشن که ساختار کلی صفحه را شامل سایدبار، هدر، و محتوای مرکزی مدیریت می‌کند.
 * از ThemeProvider برای اعمال تم سفارشی استفاده می‌کند و CssBaseline برای تنظیمات پایه‌ای MUI اضافه شده است.
 *
 * ویژگی‌ها:
 * - نمایش Sidebar ثابت در نمایشگرهای بزرگ و SidebarMobile در موبایل
 * - هدر قابل تنظیم با لوگوی سفارشی
 * - محتوای اصلی درون ContainerCustom قرار می‌گیرد
 * - پس‌زمینه با افکت گرادیان و سایه‌های زیبا برای جلوه بصری
 * - امکان باز و بسته کردن Drawer در نسخه موبایل
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - محتوای داخلی لایه
 *
 * @returns JSX.Element
 */

const Layout = (props: LayoutProps) => {
  const { children } = props;
  const [openDrawer, setOpenDrawer] = useState(false);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <StackKit direction="row" justifyContent="center" sx={{width:'100%',position: "relative",overflow: "auto",overflowX: "hidden",height: "100vh","&.css-m164qp-MuiStack-root > :not(style) ~ :not(style)": {marginLeft: "0 !important",},}}>
        <BoxKit sx={{ display: { md: "flex", lg: "none" } }}>
          <SidebarMobile setOpenDrawer={setOpenDrawer} openDrawer={openDrawer}/>
        </BoxKit>
        <BoxKit sx={{display: { xs: "none", md: "none", lg: "flex", bgcolor: "red" },}}>
          <Sidebar />
        </BoxKit>
        <StackKit direction="column" 
          sx={{ width: "100%","&.css-m164qp-MuiStack-root > :not(style) ~ :not(style)": {marginLeft: "0 !important",}, }}>
          <HeaderShare logoHeader={<LogoMerchant />} setOpenDrawer={setOpenDrawer}/>
          <ContainerCustom>
            <StackKit direction="column" sx={{width: "100%", "&.css-m164qp-MuiStack-root > :not(style) ~ :not(style)": {marginLeft: "0 !important",}, }}>
              {children}
            </StackKit>
          </ContainerCustom>
        </StackKit>
        <BoxKit sx={{width: "1173px",height: "1243px",position: "absolute",zIndex: "-1",background:"linear-gradient(309.62deg, rgba(26, 71, 60, 0.13) -0.33%, rgba(255, 255, 255, 0.13) 78.26%)",left: 0,top: "10%",transform: "translateX(-20%)",borderRadius: "50%",boxShadow: "15px 22px 51.8px 26px #09090975;",}}/>
        <BoxKit sx={{width: "986px",height: "1045px",position: "absolute",zIndex: "-1",background:"linear-gradient(309.62deg, rgba(26, 71, 60, 0.13) -0.33%, rgba(255, 255, 255, 0.13) 78.26%)",left: 0,top: "17%",transform: "translateX(-20%)",borderRadius: "50%",boxShadow: "15px 22px 51.8px 26px #09090975;",}}/>
      </StackKit>
    </ThemeProvider>
  );
};

export default Layout;
